import { mapValues } from 'lodash';
import { getScoreByImpactValence } from '.';
import { uiImpactCategoryByCode } from '../../input/impacts';
import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Valence } from '../../types';
import { ImpactScoresByIVV } from './types';

interface BiggestImpact {
  score: number;
  impactCategory: ImpactCategoryId;
  impactCategoryTitle: string;
}

export function getBiggestImpact(impactScoresByIVV: ImpactScoresByIVV, valence: Valence): BiggestImpact {
  const scoresByIV = getScoreByImpactValence(impactScoresByIVV);
  const scoresByI = mapValues(scoresByIV, scores => scores[valence] || 0);
  const impactCodes = Object.keys(scoresByI) as ImpactCategoryId[];
  const defaultCode = impactCodes[0] ? impactCodes[0] : ImpactCategoryId.GHG_EMISSIONS;
  const initialCandidate: BiggestImpact = {
    score: scoresByI[defaultCode] || 0,
    impactCategory: defaultCode,
    impactCategoryTitle: uiImpactCategoryByCode[defaultCode].title,
  };
  return impactCodes.reduce<BiggestImpact>((acc, impactCategory) => {
    const score = scoresByI[impactCategory];
    if (score >= acc.score) {
      return { score, impactCategory, impactCategoryTitle: uiImpactCategoryByCode[impactCategory].title };
    }
    return acc;
  }, initialCandidate);
}
